<template>
    <div class="col-md-12 col-lg-12 col-xl-9">

        <div class="sport-menu-tabs-sec">
            <!-- ***wallet section start here*** -->
            <WalletHeader/>

            <section class="recent-wrapper walletPage-wrap mt-0">
                <div class="container">
                    <div class="form-bank-con">
                        <div class="form-bank-wrapper"  v-if="Object.keys(paymentMethods).length > 0">
                            <div class="form-bank-item">
                                <div v-for="(paymentMethod, paymentMethodindex) in paymentMethods" :key="paymentMethodindex" @click="choosePaymentMethod(paymentMethod,paymentMethodindex)">
                                    <label class="flexRadioDefault-label" :for="'flexRadioDefault' + paymentMethodindex"  :class="{ 'active-selcted-bank' : activeTab == paymentMethodindex }">
                                        <div class="get-bonus-sec" v-if="paymentBonus?.[paymentMethod?.[0]?.method_id]">Get {{ paymentBonus?.[paymentMethod?.[0]?.method_id] }}% Bonus</div>
                                        <input class="flexRadioDefault-inp" type="radio"
                                            name="flexRadioDefault" :id="'flexRadioDefault' + paymentMethodindex"
                                            :checked="(activeTab == paymentMethodindex)">
                                        <div class="flexRadioDefault-content">
                                            <div class="bank-icon">
                                                <img loading="lazy" :src="methodIcons[paymentMethodindex]" />
                                            </div>
                                            <div class="flexRadioDefault-title">{{ paymentMethod[0].method_name }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-else class="no-need-option-avil-sec">
                            {{$t('no-deposit-options-available-contact-admin!!','No Deposit Options Available.Contact Admin!!')}}
                        </div>
                        <span v-if="selectedPaymentDetails?.[0]?.method == 'bank'">You can add through a bank transfer</span>
                    </div>
                    <div class="withdraw-sec add-account-sec" v-if="isPaymentGateway">
                        <div class="hide-input-sec payment-gateway-sec">
                            <span>
                                Pay using our payemnt gateway
                            </span>
                            <span class="matka-but-dflex pg-btn">
                                <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                            </span>
                        </div>
                    </div>
                    <div v-if="isShowDepositeBody">
                        <div class="account-data" v-for="(bank, index) in selectedPaymentDetails" :key="index" @click="selectPaymentMethodAccount(bank)">
                            <div class="upi-card-list">
                                <div class="upi-payment-content">
                                    <div class="bank-transfer-sec " :key="accountKey" :class="{ 'active' : selectPaymentAccount?.account_number == bank?.account_number }">
                                        <div class="code-list">
                                            <div class="qr_scaner_sec file-uploader-qr-wrapper" v-if="bank?.qr_code">
                                                <figure>
                                                    <img loading="lazy" :src="bank?.qr_code" alt="QR-Code">
                                                </figure>
                                                <div class="qr-btn-group">
                                                    <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrPreviewModal" @click="qrCode = bank?.qr_code">
                                                        <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                    </button>
                                                    <button class="qr-btn" data-bs-toggle="modal" data-bs-target="#qrShareModal" @click="qrCode = (bank.qr_code)">
                                                        <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                    </button>
                                                    <button class="qr-btn" @click="downloadQrImg(bank.qr_code, bank?.account_holder_name)">
                                                        <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="depositBank-item" v-if="bank?.account_number || account?.phone_number">
                                                <div class="depositBank-key">{{ bank?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_number ? bank?.account_number : account?.phone_number }}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData(bank?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number'), bank?.account_number ? bank?.account_number : bank?.phone_number)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == account?.account_number ? account?.account_number : account?.phone_number">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key">
                                                    {{ bank?.account_number ? $t('bank-name', 'Bank Name') :  $t('payment-method', 'Payment Method') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.method_name}}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData($t('bank-name', 'Bank Name'), bank.method_name)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank.method_name">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key">{{ bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id) }}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData(bank?.account_number ? $t('ifsc-code', 'IFSC Code') : bank?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.crypto_wallet_id))">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank?.account_number ? bank?.ifsc_code : (bank?.upi_id || bank?.wallet_id)">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item">
                                                <div class="depositBank-key" :id="'account:' + accountKey">{{$t('account-holder-name', 'Account Holder Name')}}
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">{{ bank?.account_holder_name}}</div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData('Account Holder Name', bank.account_holder_name)">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                    <!-- <div class="copt_text_hover" v-if="copiedText == bank.account_holder_name">
                                                        {{ $t('copied', ' Copied') }}!
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="depositBank-item" v-if="bank?.crypto_wallet_id">
                                                <div class="depositBank-key" :id="'account:' + accountKey">Deposit Amount
                                                    <span class="list-dost">:</span>
                                                </div>
                                                <div class="depositBank-value">
                                                    {{ (depositAmount/bank?.multiplier_value)?.toFixed(2) }} {{ bank?.method_name}}
                                                    <span>( at x{{ Number(bank?.multiplier_value) }} )</span>
                                                </div>
                                                <div class="copy-btn-tool-tips-sec">
                                                    <button class="copy-icon" @click="copyPaymentData('Deposit Amount', (depositAmount/bank?.multiplier_value))">
                                                        <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bank-upi-sec">
                            <div class="withdraw-sec add-account-sec position-relative mt-1">
                                <div class="uploadFile-wrap" v-if="!previewImageUtr">
                                    <h5 class="uploadFile-title-wrap">{{$t('upload-your-payment-slip-below', 'Upload your payment slip below')}} <small style="color: red;">*</small>
                                        <!-- <span class="info-sec-icon">
                                            <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                            <div class="info-tooltip">
                                                <ul>
                                                    <li>1. {{$t('upload-a-screenshot-of-a-valid-qr-code-to-proceed', 'Upload a screenshot of a valid QR code to proceed')}}</li>
                                                    <li>2. {{$t('if-qr-code-is-not-detected-exchange-will-not-be-responsible-for-the-losses', 'If QR code is not detected, Exchange will not be responsible for the losses')}}</li>
                                                </ul>
                                            </div>
                                        </span> -->
                                    </h5>
                                    <div class="file-upload-sec input-field">
                                        <label for="file" class="file-upload">
                                            <img loading="lazy" src="@/assets/images/file-icon.svg" alt="file-icon">
                                            <h6>{{$t('upload-screenshot', 'Upload screenshot')}}</h6>
                                        </label>
                                        <input class="form-control profit-input d-none" @click="onFilePickerOpen" ref="fileRef" type="file" name="file"
                                                id="file" @change="fileUpdateFunc" accept=".png, .jpg, .jpeg, .webp">
                                    
                                        <div class="thm-error-text" v-if="showFileError && !previewImageUtr">
                                            <div>
                                                <p class="wrong-color">{{ $t('please-upload-payment-proof', 'Please Upload Payment Proof') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-field" v-if="previewImageUtr">
                                    <div class="uploadFile-wrap">
                                        <h5 class="uploadFile-title-wrap">{{$t('payment-slip', 'Payment Slip')}}</h5>
                                        <div class="fileList">
                                            <img class="fileList-img" :src="previewImageUtr"  alt="file" loading="lazy"/>
                                            <button class="add-utr-again" @click="clearPaymentSlip()">&#10006;</button>
                                            <div class="timer loader_timer" v-if="utrLoader">
                                                <div class="loader_deposit">
                                                </div>
                                                <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                    {{ timerValue }}
                                                </text>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="paymentProofFileUploadStatus"v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>                                                                
                                </div>
                                <div class="input-field">
                                    <label class="form-label">{{ $t('utr-number','UTR Number')}} 
                                        <small style="color: red;" v-if="selectPaymentAccount?.method != 'wallet'">*</small></label>
                                    <input class="form-control" type="text" v-model="utrNumber" :disabled="utrLoader" @input="validateUTR(), manualUtrNumber = 1" :placeholder="$t('enter-utr-number', 'Enter UTR number')" :maxlength="selectPaymentAccount?.method != 'wallet' ? 15 : 128"/>
                                    <!-- ****** for eroor text ***** -->
                                    <div class="thm-error-text" v-if="selectPaymentAccount?.method != 'wallet' && utrerror && init">
                                        <div>
                                            <p class="wrong-color">{{$t('enter-valid-utr','Please Enter UTR Number')}}</p>
                                        </div>
                                    </div>
                                    <div class="thm-error-text" v-if="selectPaymentAccount?.method != 'wallet' && utrLimitError && init">
                                        <div>
                                            <p class="wrong-color">{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-field">
                                    <label for="exampleFormControlInput1">{{ $t('amount', 'Amount') }} <small style="color: red;">*</small></label>
                                    <input type="number" class="form-control btn-disabled" v-model="amount" readonly />
                                </div>
                            </div>
                        </div>
                        <div class="withdraw-fix-sec continue-btn">
                            <a ref="sbtBtn" @click="walletDepositSubmitBtn()" type="button" id="account-successfully" class="btnTheme-yellow " :class="{ 'btn-loading': loading }">{{$t('submit-request', 'Submit Request')}} <span><b></b><b></b><b></b></span></a>
                        </div>
                    </div>
                    <WalletInstructions instructionType="deposit" />
                </div>
            </section>

            <QrCodeModal :qrCode="qrCode"/>
            <QrCodeShareModal :qrCode="qrCode"/>

            
        </div>
        <Support></Support>
    </div>
    <AdvertSideBar></AdvertSideBar>
    <Loader v-if="loading" />
</template>

<script setup>
import { ref, computed , inject , onMounted , getCurrentInstance } from 'vue';
import {  
    getParentPaymentsMethods,
    onUploadImage,
    submitDepositAmount,
    getPaymentGatewayUrl
} from '../services/depositPayment';
import WalletInstructions from '../components/WalletInstructions.vue';
import QrCodeShareModal from '../components/QrCodeShareModal.vue';
import Loader from '@/shared/components/loader/Loader.vue';
import QrCodeModal from '../components/QrCodeModal.vue';
import WalletHeader from '../components/WalletHeader.vue';
import Support from '@/shared/components/support/Support.vue';
import AdvertSideBar from '@/shared/components/advertisment/AdvertSideBar.vue';
import { useStore } from 'vuex'
import { useRouter } from 'vue-router';
const { $t, $errorToast, $successToast, $siteSettings } = getCurrentInstance().proxy;

const store = useStore();
const router = useRouter();
const walletConfig = inject('walletConfig')
// refs
const socialLink = ref(false);
const has_edited_utr = ref(1);
const paymentMethods = ref([]);
// const selectedPaymentMethod = ref([]);
const utrNumber = ref(null);
const fetchedUtr = ref(null);
const file = ref(undefined);
const loading = ref(false);
const selectPaymentAccount = ref(null);
const selectedPaymentDetails = ref([]);
const previewImageUtr = ref(null);
const manualUtrNumber = ref(0);
const qrCode = ref(null);
const utrLoader = ref(false);
const t = ref(6);
const interval = ref(30);
const angle = ref(0);
const angle_increment = ref(360 / 9);
const intervalCounter = ref(0);
const timerValue = ref(9);
const copiedText = ref('');
const uploadedImage = ref(null);
const timer = ref(null);
const amount = ref(null);
const showFileError = ref(false);
const utrerror = ref(false);
const utrLimitError = ref(false);
const init = ref(false);
// const currentImgLink = ref(null);
const activeTab =ref(null);
const isPaymentGateway = ref(null);
const paymentProofFileUploadStatus = ref('');
// template refs
const sbtBtn = ref(null);
const fileRef = ref(null);

// computed
const bonusData = computed(() => store.getters?.bonusData);
const depositAmount = computed(() => store.getters?.depositAmount);
// const siteSettings = computed(() => store.getters?.siteSettings);
const methodIcons = computed(() => {
    let iconObj = {};
    walletConfig.value?.payment_method?.forEach(element => {
        iconObj[element.method_name] = element.icon
    });
    walletConfig.value?.bank_list?.forEach(element => {
        iconObj[element.bank_name] = element.icon
    });
    return iconObj
});
const paymentBonus = computed(() => {
    if (!bonusData.value || !Array.isArray(bonusData.value)) {
        return {};
    }

    const paymentBonusData = bonusData.value?.filter(bd => bd.bonusType === 'payment bonus');

    if (paymentBonusData.length === 0) {
        return {};
    }

    return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
        try {
            const methodIds = JSON.parse(bonusElement.methodIds);
            if (Array.isArray(methodIds)) {
                methodIds.forEach(methodId => {
                    methodBonusMap[methodId] = bonusElement.percentage;
                });
            }
        } catch (error) {
            console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
        }
        return methodBonusMap;
    }, {})
});

const isShowDepositeBody = computed(()=> selectedPaymentDetails.value?.length && !isPaymentGateway.value && selectedPaymentDetails.value?.[0]?.method !== 'social');

// methods
function selectPaymentMethodAccount(paymentAccount) {
    socialLink.value = false
    selectPaymentAccount.value = paymentAccount;
};
async function getParentPaymentMethods(reconnectTry = 0) {
    try {
        let response = await getParentPaymentsMethods(reconnectTry, depositAmount.value);
        if (response?.data) {
            paymentMethods.value = response?.data;
            let nonSocialStartIndex = response?.nonSocialStartIndex
            activeTab.value = Object.keys(paymentMethods.value)[nonSocialStartIndex]
            choosePaymentMethod(paymentMethods.value?.[activeTab.value], activeTab.value);
        }
    } catch (error) {

        if (reconnectTry < 3 && !error) {
            getParentPaymentMethods(reconnectTry + 1);
        }
        else {
            loading.value = false;
            store.dispatch('setGlobalLoader', false);
            if (error) {
                console.log('error', error);
                router.back();
                $errorToast(error[0]);
            }
        }
    }
};
function capitalizeText(text) {
    if (typeof text == 'string') {
        text = text.trim();
        return text.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    } else
        return text
};
async function copyPaymentData(catagory, accountData) {
    try {
        await navigator.clipboard.writeText(accountData);
        copiedText.value = accountData;
        $successToast(capitalizeText(catagory + ' ' + 'Copied Successfully'))
        setTimeout(() => {
            copiedText.value = null;
            document.querySelectorAll('copy-icon').forEach(el => {
                el.style.color = '#000000';
            });
        }, 1000);
    } catch (err) {
        console.log('err: ', err);
        console.error(capitalizeText('Failed to copy: ', err));
    }
};
// function copyImgUrl() {
//     var input = document.createElement('textarea');
//     input.innerHTML = this.currentImgLink;
//     document.body.appendChild(input);
//     input.select();
//     document.execCommand('copy');
//     document.body.removeChild(input);
//     $successToast('Successfully copied.');
// };

function downloadQrImg(imageUrl, name) {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = name;
    link.target = '_blank';
    link.click();
};

function walletDepositSubmitBtn() {
    init.value = true;
    if (!selectPaymentAccount.value) {
        console.log('selectPaymentAccount.value: ', selectPaymentAccount.value);
        $errorToast('Please select a payment method.');
        return
    } 
    // else if (!uploadedImage.value || file.value == null) {
    //     showFileError.value = true;
    //     validateUTR();
    //     return;
    // }
    walletDepositServiceCall();
};
async function walletDepositServiceCall() {
    if(!uploadedImage.value) {
        showFileError.value = true;
        validateUTR();
        return;
    };
    if (selectPaymentAccount.value?.method != 'wallet' && (utrNumber.value?.length < 10 || !utrNumber.value) ) return;
    has_edited_utr.value = fetchedUtr.value == utrNumber.value ? 0 : 1;
    try {
        loading.value = true;
        let response = await submitDepositAmount({
            accountDetails: selectPaymentAccount.value,
            uploadedImage: uploadedImage.value,
            depositAmount: depositAmount.value,
            manual_utr: utrNumber.value,
            has_edited_utr: has_edited_utr.value,
            removeImage: clearPaymentSlip
        });
        console.log(response)
        loading.value = false;
    } catch (error) {
        console.log('eroror', error);
        $errorToast(error)
        loading.value = false;
    }
};
// function getAutoUrlServiceCall() {
//     loading.value = true;
//     let formData = new FormData();
//     formData.append('file', file.value);
//     formData.append('amount', depositAmount.value);
//     $apiCall('post', 'GET_AUTO_UTR', formData, 'wallet', null, 'changeHeaderContent')
//         .then(response => {
//             loading.value = false;
//             resetTimer();
//             if (response) {
//                 if (response.status == 200) {
//                     if (response?.data?.utr) {
//                         utrNumber.value = response?.data?.utr_number;
//                     }
//                 }
//             }
//         }).catch(error => {
//             loading.value = false;
//             resetTimer();
//             file.value = undefined;
//             previewImageUtr.value = null;
//             if (error) {
//                 $errorToast(error[0]);
//             }
//         });
// };
// async function recognize(prevImgs) {
//     try {
//         const img = prevImgs;
//         const worker = await createWorker('eng');
//         let { data: { text } } = await worker.recognize(img);
//         await worker.terminate();
//         return checkAll(text);
//     } catch (e) {
//         $errorToast('Try again with different image!')
//     }
// };
async function fileUpdateFunc(event) {
        has_edited_utr.value = 1
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const file = event.target.files?.[0];
        // Only proceed if at least one file is selected
        if (!file) {
            return $errorToast($t('no-file-selected','No File selected to upload'))
        }
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        const maxFileSize = 5 * 1024 * 1024; 
        if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
            $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
            previewImageUtr.value = null;
            return;
        }
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';   
        file.value = file;
        previewImageUtr.value = URL.createObjectURL(file)
        let response = await onUploadImage({
            event,
            depositAmount: depositAmount.value,
            startTimer: startTimer,
            resetTimer: resetTimer,
            sbtBtn: sbtBtn.value,
            paymentProofFileUploadStatus:paymentProofFileUploadStatus
        });
        if (response) {
            if(!response?.manual_utr){
              paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }
            utrNumber.value = response?.manual_utr
            // utrMsg.value = response?.utrMsg
            uploadedImage.value = response?.uploadedImage
            previewImageUtr.value = response?.previewImage
            utrNumber.value = response?.tesseract_utr
            fetchedUtr.value = response?.tesseract_utr
            utrLoader.value = false
        }
        else {
            // this.previewImage = null
            // this.fetchedUtr = null
            // this.previewImageUtr = null
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        }
        validateUTR()
    }
    catch (error) {
        previewImageUtr.value = null;
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
        $errorToast($t('try-again-with-different-image', 'Try again with different image!'));
    }
     finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
};
function clearPaymentSlip() {
    has_edited_utr.value = 1
    previewImageUtr.value = null;
    utrNumber.value = null;
    file.value = undefined;
    uploadedImage.value = null
    loading.value = false

    validateUTR();
};
async function goToPaymentGateway() {
    try {
        const response = await getPaymentGatewayUrl(depositAmount.value, selectedPaymentDetails.value?.[0]?.master_account_id);
        console.log(response)
    } catch (error) {
        $errorToast(error)
    }
};
function choosePaymentMethod(payment, index) {
    clearPaymentSlip()
    // this.toggleInit(false) 
    activeTab.value = index
    selectedPaymentDetails.value = payment
    if (payment?.[0]?.method == 'social') {
        isPaymentGateway.value = false;
        const socialNumber = payment?.[0]?.social_payment_number;
        const socialLink = payment?.[0]?.social_payment_link;
        if (socialNumber?.length && socialLink?.length) {
            const choice = Math.random() < 0.5 ? 'number' : 'link';
            if (choice === 'number') {
                if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                    window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                    window.open(`https://t.me/${socialNumber}`, 'blank');
                }
            } else {
                window.open(socialLink, 'blank');
            }
            return;
        }
        if (socialNumber?.length) {
            if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
            } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                window.open(`https://t.me/${socialNumber}`, 'blank');
            }
            return;
        }
        if (socialLink?.length) {
            window.open(socialLink, 'blank');
            return;
        }
        $errorToast($t('no-social-payment-number', 'No social payment number available'));
        return;
    };
    if (payment?.[0]?.method == 'payment_gateway') {
        isPaymentGateway.value = true;
        selectedPaymentDetails.value = payment;
        return
    }
    activeTab.value = index
    selectedPaymentDetails.value = payment
    selectPaymentAccount.value = selectedPaymentDetails.value?.[0]
    isPaymentGateway.value = false;
    showFileError.value = false
    utrerror.value = false
    init.value = false
};
function validateUTR() {
    utrNumber.value = utrNumber.value?.replace(/[^0-9]/g, '')?.replace(/[+-]/g, '');
    if (!utrNumber.value) {
        utrerror.value = true;
        utrLimitError.value = false;
    } else if (utrNumber.value.length < 10 || utrNumber.value.length > 15) {
        utrerror.value = false;
        utrLimitError.value = true;
    } else {
        utrerror.value = false;
        utrLimitError.value = false;
    }
};
function startTimer() {
    utrLoader.value = true;
    timer.value = setInterval(() => {
        intervalCounter.value++;
        angle.value += angle_increment.value / (1000 / interval.value);

        // Update the timer value based on the angle
        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

        if (angle.value >= 360) {
            clearInterval(timer.value);
        }
        if (timerValue.value <= 0) {
            resetTimer();
            // $errorToast('Time out! Please try again with a different image or manually enter the UTR number.');
            utrLoader.value = false;
        }
    }, interval.value);
};
function resetTimer() {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
};
function onFilePickerOpen() { 
    window.addEventListener('focus', () => {        
        setTimeout(() => {
            const files = fileRef.value?.files;
            if (files?.length == 0) {
                $errorToast('File not selected. Check permission or try again!!')
            }
        }, 1000);
    }, { once: true })
}

// hooks
onMounted(() => {
    getParentPaymentMethods();
    amount.value = store.getters.depositAmount;
    socialLink.value = false;
})
</script>